export const mainStyles = {
  minHeight: "100vh",
  width: "100%",
  backgroundColor: "#fff",
};
